// export default [
//   { w: "120", h: "600" },
//   { w: "180", h: "600" },
//   { w: "300", h: "250" },
//   { w: "300", h: "600" },
//   { w: "720", h: "300" },
//   { w: "970", h: "90" },
//   { w: "970", h: "250" },
// ];

export default [
  { width: "120", height: "600" },
  { width: "180", height: "600" },
  { width: "300", height: "250" },
  { width: "300", height: "600" },
  { width: "720", height: "300" },
  { width: "970", height: "90" },
  { width: "970", height: "250" },
];
